export default function Panel({
  title,
  className = "",
  children,
}) {
  return (
    <div
      className={`
        relative
        flex
        h-full
        w-full
        flex-col
        overflow-hidden
        rounded-[65px]
        bg-[#efefef]
        px-4
        py-10
        sm:px-5
        sm:py-12
        md:rounded-[100px]
        md:px-6
        md:py-24
        lg:rounded-[135px]
        ${className}
      `}
    >
      <p className="shrink-0 text-center font-minecraft text-xs uppercase tracking-[0.2em] text-neutral-700 sm:text-sm">
        {title}
      </p>

      <div className="min-h-0 flex-1">
        {children}
      </div>
    </div>
  );
}